var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"padding-top":"3rem"}},[(_vm.showGoogleMap)?_c('div',{staticClass:"eventos-map card"},[_c('div',{staticClass:"header"},[_vm._v("Visão geral no mapa")]),_vm._v(" "),_c('google-maps',{attrs:{"eventsSpecifications":_vm.eventsSpecifications,"trgMarkerCoordinates":_vm.events,"tags":_vm.listTags,"eduMarkerCoodinates":_vm.speeches}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-903602a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/showMap.vue
// module id = 60fs
// module chunks = 10